import styled from '@emotion/styled'

export const UploadForm = styled.form`
  display: flex;
  width: 100%;
`
